import { render } from "./long-insure-worker.vue?vue&type=template&id=34891a11&scoped=true&ts=true"
import script from "./long-insure-worker.vue?vue&type=script&lang=ts"
export * from "./long-insure-worker.vue?vue&type=script&lang=ts"

import "./long-insure-worker.vue?vue&type=style&index=0&id=34891a11&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34891a11"]])

export default __exports__